import React from "react";
import {
  withStyles,
  Divider,
  Grid,
  Button,
  CircularProgress,
  TextField,
  withTheme,
} from "@material-ui/core";
import { observer, inject } from "mobx-react";
import Cancel from "@material-ui/icons/Cancel";
import InputAdornment from "@material-ui/core/InputAdornment";
import { postData } from "../../../../../../api/componentAPIs";
import Select from "../../../../../common/StyledSelect";
import { withSnackbar } from "notistack";
import { compose } from "recompose";
import GeocoderSearch from "../../../../Common/GeocoderSearchBox";
import { DateTimeEditor } from "../../../../../dataGrid/cellEditors";
import {
  convertDateTimeToTimeString,
  isTimeValid,
} from "../../../../../dataGrid/gridUtilities";
import appConstants from "../../../../../../appConstants";

const styles = (theme) => ({
  container: {
    minWidth: 320,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
  },
  content: {
    flexGrow: 1,
    overflow: "auto",
  },
  divider: {
    backgroundColor: theme.AppBGColor,
  },
  head: {
    fontSize: 14,
    color: theme.HeaderSelectedText,
    padding: "8px 24px",
    fontWeight: 600,
    flexBasis: "auto",
  },
  dataContainer: {
    padding: "8px 24px",
    fontSize: "12px",
    lineHeight: "16px",
    color: theme.gridTextColor,
  },
  anchorpointFormContainer: {
    display: "flex",
    paddingTop: 16,
    paddingBottom: 16,
  },
  footer: {
    padding: "24px 24px",
    display: "flex",
    justifyContent: "space-between",
  },
  updateAnchorPointButton: {
    minWidth: "55%",
    "&$disabledButton": {
      backgroundColor: theme.iconColor,
    },
  },
  disabledButton: {
    backgroundColor: theme.iconColor,
  },
  circularProgress: {
    color: theme.white,
  },
  flexRow: {
    display: "flex",
    direction: "column",
    "&>div": {
      flex: 1,
      width: "100%",
    },
  },
  fieldRoot: {},
  label: {
    color: theme.TextColor,
    transform: "translate(14px, 14px) scale(1)",
    fontSize: theme.headerTextFontSize,
    opacity: 0.7,
  },
  notchedOutline: {},
  inputRoot: {
    "& $notchedOutline,&:hover:not($inputFocused):not($inputError) $notchedOutline":
      {
        borderColor: theme.iconColor,
      },
  },
  inputFocused: {},
  inputDisabled: {
    background: theme.tooltipBGColor,
    "& $notchedOutline, &:not($inputFocused):not($inputError) $notchedOutline":
      {
        borderColor: theme.iconColor,
      },
  },
  inputError: {},
  inputField: {
    padding: 12,
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    height: "initial",
  },
  iconClass: {
    color: theme.iconColor,
    cursor: "pointer",
  },
  gridContainer: { margin: "0px", padding: "10px", width: "100%" },
  divStyle: { width: "100%" },
  editorContainer: {
    marginTop: "16px",
    marginBottom: "8px",
    "&.error": {
      ".mapboxgl-ctrl-geocoder--input": {
        border: "solid 1px $error-color",
      },
    },
  },
  errorMessageVisible: {
    display: "block",
    margin: "5px 0px 0px 12px",
    color: theme.ErrorMessageColor,
    fontSize: theme.textFontSize,
  },
  editorContainerTime: {
    marginTop: "8px",
    marginBottom: "8px",
    "&>div": {
      maxWidth: "100%",
      marginTop: 0,
      "&>div": {
        width: "100%",
        "&>div": {
          maxWidth: "100%",
          height: 40,
          borderRadius: 4,
          marginTop : 12
        },
      },
    },
  },
  editorContainerTimeerror: {
    marginTop: "8px",
    marginBottom: "8px",
    "&>div": {
      maxWidth: "100%",
      marginTop: 0,
      "&>div": {
        width: "100%",
        "&>div": {
          maxWidth: "100%",
          height: 40,
          borderRadius: 4,
          borderColor: `${theme.ErrorMessageColor}`,
          marginTop : 12
        },
      },
    },
  },
  labelProps: {
    fontSize: theme.headerTextFontSize,
    backgroundColor: theme.gridBGColor,
    color: theme.iconColor,
    padding: "0px 4px 0px 4px",
  },
  filledLabel : {
    top: 4,
    left: 8,
    "&$shrink" : {
      transform : "translate(4px, 2px) scale(0.75)"
    }
  },
  shrink: {},
  timeEditorInput : {
    background : "transparent",
    "&:hover,&$timeEditorInputFocused": {
      background : "transparent"
    },
  },
  timeEditorInputFocused: {}
});

@inject("IBPlanningStore")
@observer
class AddUpdateAnchorPoint extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: null,
      errorInfo: {},
      updateInProgress: false,
      anchorPointsInfo: this.getDefaulAnchorPointInfo(),
      inputValue: null,
    };
    this.emptyTimeRef = React.createRef();
    this.exisitingAnchorPointNames = this.props.data.map((anchorPoint) => {
      return anchorPoint.anchorPointName;
    });
  }

  componentDidUpdate(prevProps) {
    if (!Object.is(this.props.anchorPointsInfo, prevProps.anchorPointsInfo)) {
      this.setState({
        anchorPointsInfo: this.getDefaulAnchorPointInfo(),
        errorInfo: {},
        errorMessage: null,
        inputValue: this.props.anchorPointsInfo
          ? `${this.props.anchorPointsInfo.latitude},${this.props.anchorPointsInfo.longitude}`
          : "",
      });
    } else if (this.props.error !== prevProps.error) {
      this.setState({
        errorMessage: this.props.error,
      });
    }
    if (
      this.props.anchorPointsPosition &&
      !Object.is(
        this.props.anchorPointsPosition,
        prevProps.anchorPointsPosition
      ) &&
      this.props.anchorPointsPosition?.latitude !==
        this.state.anchorPointsInfo?.latitude &&
      this.props.anchorPointsPosition?.longitude !==
        this.state.anchorPointsInfo?.longitude
    ) {
      //if position of marker changes in a map this will update it in the geocoder
      this.setState({
        inputValue: `${this.props.anchorPointsPosition.latitude},${this.props.anchorPointsPosition.longitude}`,
      });
    }
  }
  getDefaulAnchorPointInfo() {
    return {
      searchAddress: "",
      latitude: this.props.anchorPointsInfo?.latitude || "",
      longitude: this.props.anchorPointsInfo?.longitude || "",
      zip: this.props.anchorPointsInfo?.zip || "",
      routeNames: this.props.anchorPointsInfo?.routeAssigned?.trim() || "",
      anchorPointName: this.props.anchorPointsInfo?.anchorPointName || "",
      emptyTime: this.props.anchorPointsInfo?.emptyTime || "",
    };
  }

  // Update anchorPointsInfo based on inputs
  handleChange = (name) => (value) => {
    if (name === "routeNames") {
      value = value && value.map((route) => route.label).join(",");
    }
    this.setState((state) => ({
      anchorPointsInfo: {
        ...state.anchorPointsInfo,
        [name]: value,
      },
      errorInfo: {
        ...state.errorInfo,
        [name]: this.getFieldError(name, value),
      },
      errorMessage: null,
    }));
  };
  onSeachAddressBlur = (event) => {
    if (
      event.target.value &&
      !this.state.anchorPointsInfo.longitude &&
      !this.state.anchorPointsInfo.latitude
    ) {
      this.getLatLongFromAddress(event.target.value);
    }
  };
  // Clear value in the field
  clearField = (field) => (event) => {
    this.handleChange(field)("");
  };
  getFieldIcon = (field, readOnly) => {
    const { classes } = this.props;
    if (this.state.anchorPointsInfo[field] && !readOnly) {
      return (
        <InputAdornment>
          <Cancel
            onClick={this.clearField(field)}
            classes={{ root: classes.iconClass }}
          />
        </InputAdornment>
      );
    }
    return null;
  };
  // Checks for errors for each field
  getFieldError = (field, value) => {
    const errorMessage =
      !this.props.anchorPointsInfo &&
      value &&
      this.exisitingAnchorPointNames.includes(value)
        ? "* Anchor point name must be unique"
        : null;
    switch (field) {
      case "searchAddress":
        return value+"" && value.trim() ? null : "*  Search address is required";
      case "emptyTime":
        return value && value.trim() ? null : "* Empty time is required";
      case "anchorPointName":
        return value && value.trim() ? errorMessage : "* Anchor point name is required";
      default:
        return null;
    }
  };
  // Set Error messages for each field
  getErrorInfo = () => {
    let errorInfo = {};
    Object.keys(this.state.anchorPointsInfo).forEach((fieldName) => {
      errorInfo[fieldName] = this.getFieldError(
        fieldName,
        this.state.anchorPointsInfo[fieldName]
      );
    });
    this.setState({
      errorInfo,
    });
    return errorInfo;
  };

  // get common props for all the text fields
  getTextFieldDefaultProps = (fieldName, classes) => {
    return {
      id: fieldName,
      autoComplete: "off",
      classes: {
        root: classes.fieldRoot,
      },
      InputLabelProps: {
        classes: {
          root: classes.label,
        },
      },
      InputProps: {
        classes: {
          root: classes.inputRoot,
          input: classes.inputField,
          notchedOutline: classes.notchedOutline,
          focused: classes.inputFocused,
          disabled: classes.inputDisabled,
          error: classes.inputError,
        },
        endAdornment: this.getFieldIcon(
          fieldName,
          Boolean(this.props.anchorPointsInfo)
        ),
        disabled: Boolean(this.props.anchorPointsInfo),
      },
      value: this.state.anchorPointsInfo[fieldName],
      onChange: (event) =>
        this.handleChange(fieldName)(
          event && event.target ? event.target.value : ""
        ),
      margin: "normal",
      variant: "outlined",
      error: Boolean(this.state.errorInfo[fieldName]),
      helperText: this.state.errorInfo[fieldName],
    };
  };
  addAnchorPoint = () => {
    const errorInfo = this.getErrorInfo();
    const errorData = Object.values(errorInfo).filter((value) => value).length;
    if (!errorData) {
      const data = this.setRequestObject();
      this.setState({ updateInProgress: true });
      postData("CreateAnchorPoint", data).then(
        (response) => {
          if (response && response.status >= 200 && response.status < 400) {
            this.props.updateAnchorPointDataInStore();
            this.props.onClose();
            this.props.enqueueSnackbar(
              `Anchor point ${this.state.anchorPointsInfo.anchorPointName} added`,
              { variant: "success" }
            );
          } else {
            this.handleError("adding");
          }
          this.setState({ updateInProgress: false });
        },
        (error) => {
          this.setState({ updateInProgress: false });
          this.handleError("adding");
        }
      );
    }
  };
  updateEmptyTime = (emptyTime) => {
    if (!emptyTime) {
      this.handleChange("emptyTime")(null);
      return;
    }
    if (this.emptyTimeRef) {
      const timeString = convertDateTimeToTimeString(
        this.emptyTimeRef.getValue()
      );
      if (isTimeValid(timeString)) {
        this.handleChange("emptyTime")(timeString);
      }
    }
  };
  updateAnchorPoint = () => {
    const errorInfo = this.getErrorInfo();
    const errorData = Object.values(errorInfo).filter((value) => value).length;
    if (!errorData) {
      const data = this.setRequestObject();
      data["isSelected"] = this.props.anchorPointsInfo.isSelected;
      this.setState({ updateInProgress: true });
      postData("UpdateAnchorPoint", data).then(
        (response) => {
          if (response && response.status >= 200 && response.status < 400) {
            this.props.updateAnchorPointDataInStore();
            this.props.onClose();
            this.props.enqueueSnackbar(
              `Anchor point ${this.state.anchorPointsInfo.anchorPointName} updated`,
              { variant: "success" }
            );
          } else {
            this.handleError("updating");
          }
          this.setState({ updateInProgress: false });
        },
        (error) => {
          this.setState({ updateInProgress: false });
          this.handleError("updating");
        }
      );
    }
  };
  setRequestObject = () => {
    return {
      scenarioId: this.props.scenarioId,
      anchorPointName: this.state.anchorPointsInfo.anchorPointName,
      latitude: this.state.anchorPointsInfo.latitude,
      longitude: this.state.anchorPointsInfo.longitude,
      emptyTime: this.state.anchorPointsInfo.emptyTime,
      zip: this.state.anchorPointsInfo.zip,
      routeNames: this.state.anchorPointsInfo.routeNames
        ? this.state.anchorPointsInfo.routeNames.split(",")
        : [],
    };
  };
  handleError = (Type) => {
    this.props.enqueueSnackbar(
      `Error while ${Type} anchor point ${this.state.anchorPointsInfo.anchorPointName}`,
      { variant: "error" }
    );
  };
  getLocationDetails = ([longitude, latitude], zip, address) => {
    if (longitude && latitude && address) {
      this.setState({
        anchorPointsInfo: {
          ...this.state.anchorPointsInfo,
          ["latitude"]: latitude,
          ["longitude"]: longitude,
          ["zip"]: zip,
        },
      });
      this.handleChange("searchAddress")(address);
      if (this.state.anchorPointsInfo?.searchAddress !== address) {
        this.props.anchorPointsPositionChange({
          latitude: latitude,
          longitude: longitude,
        });
      }
    } else {
      if (this.props.anchorPointsInfo) {
        this.setState({
          inputValue: `${this.props.anchorPointsInfo.latitude},${this.props.anchorPointsInfo.longitude}`,
        });
      }
      this.props.anchorPointsPositionChange(null);
    }
  };
  getAddress = () => {
    if (this.props.anchorPointsInfo) {
      this.setState({
        inputValue: `${this.props.anchorPointsInfo.latitude},${this.props.anchorPointsInfo.longitude}`,
      });
      return `${this.props.anchorPointsInfo.latitude},${this.props.anchorPointsInfo.longitude}`;
    }
    return "";
  };
  render() {
    const { classes, theme } = this.props;
    const { anchorPointsInfo, errorInfo } = this.state;
    const buttonText = this.props.anchorPointsInfo
      ? "Update Anchor Point"
      : "Create Anchor Point";

    const routeList = this.props.IBPlanningStore.routesList
      .filter((route) => route.routeName !== appConstants.UNRTD_ROUTENAME)
      .map((route) => {
        return { label: route.routeName, value: route.routeName };
      });
    return (
      <div className={`${classes.container} addUpdateAnchorPointForm`}>
        <div>
          <Grid item xs={12} className={classes.head}>
            {this.props.anchorPointsInfo
              ? "Update Anchor Point"
              : "Add New Anchor Point"}
          </Grid>
          <Divider className={classes.divider} />
        </div>

        <div className={`${classes.content} customScroll`}>
          <div
            className={`${classes.dataContainer} ${classes.anchorpointFormContainer}`}
          >
            <Grid container spacing={24} className={classes.gridContainer}>
              <div className={classes.divStyle}>
                <form className={classes.form} noValidate>
                  <div className={classes.flexRow}>
                    <div
                      className={`${classes.editorContainer} ${
                        Boolean(errorInfo.searchAddress) && "error"
                      }`}
                    >
                      <GeocoderSearch
                        getLocationDetails={this.getLocationDetails}
                        inputValue={
                          this.state.inputValue
                            ? this.state.inputValue
                            : this.getAddress()
                        }
                        originalLat={this.props.anchorPointsInfo?.latitude}
                        originalLng={this.props.anchorPointsInfo?.longitude}
                        geocoderTheme={theme.themeName}
                        error={Boolean(errorInfo.searchAddress)}
                      ></GeocoderSearch>
                      {Boolean(errorInfo.searchAddress) && (
                        <div
                          className={`MuiFormHelperText-root MuiFormHelperText-error ${classes.errorMessageVisible}`}
                        >
                          {errorInfo.searchAddress}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className={classes.flexRow}>
                    <TextField
                      {...this.getTextFieldDefaultProps(
                        "anchorPointName",
                        classes
                      )}
                      label="Anchor Point Name"
                      value={anchorPointsInfo.anchorPointName || ""}
                    />
                  </div>
                  <div className={classes.flexRow}>
                    <Select
                      textFieldProps={{
                        id: "routeNames",
                        label: "Route",
                        variant: "outlined",
                        helperText: errorInfo.routeNames,
                      }}
                      value={
                        anchorPointsInfo.routeNames &&
                        anchorPointsInfo.routeNames.split(",")
                      }
                      isMulti={true}
                      error={Boolean(errorInfo.routeNames)}
                      onChange={this.handleChange("routeNames")}
                      data={routeList}
                    />
                  </div>
                  <div className={classes.flexRow}>
                    <div
                      className={
                        Boolean(errorInfo.emptyTime)
                          ? classes.editorContainerTimeerror
                          : classes.editorContainerTime
                      }
                    >
                      <DateTimeEditor
                        dateType={{
                          type: "Time",
                          format: "HH:mm",
                          inputMask: [/\d/, /\d/, ":", /\d/, /\d/],
                          intervalSeperator: "-",
                          updateFormat: "yyyy-MM-dd'T'HH:mm:00.000Z",
                        }}
                        InputLabelProps={{
                          classes: {
                            root: classes.labelProps,
                            filled : classes.filledLabel,
                            shrink : classes.shrink
                          },
                        }}
                        inputRootClass={classes.timeEditorInput}
                        label="Empty Time"
                        ref={(ref) => (this.emptyTimeRef = ref)}
                        value={anchorPointsInfo.emptyTime}
                        onChange={this.updateEmptyTime}
                        variant="filled"
                        disableFocus
                        enablePickerPortal
                        disableFocusInput
                        inputFocusedClass = {classes.timeEditorInputFocused}
                      />
                      {Boolean(errorInfo.emptyTime) && (
                        <p
                          className={`MuiFormHelperText-root MuiFormHelperText-error ${classes.errorMessageVisible}`}
                        >
                          {errorInfo.emptyTime}
                        </p>
                      )}
                    </div>
                  </div>
                </form>
                {this.state.errorMessage && (
                  <div className={classes.errorMessage}>
                    {this.state.errorMessage}
                  </div>
                )}
              </div>
            </Grid>
          </div>
        </div>
        <div className={classes.footer}>
          <Button
            color="primary"
            variant="outlined"
            className={classes.cancelButton}
            onClick={this.props.onClose}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            variant="contained"
            classes={{
              root: classes.updateAnchorPointButton,
              disabled: classes.disabledButton,
            }}
            onClick={
              this.props.anchorPointsInfo
                ? this.updateAnchorPoint
                : this.addAnchorPoint
            }
          >
            {this.state.updateInProgress ? (
              <CircularProgress
                size={16}
                classes={{ root: classes.circularProgress }}
              />
            ) : (
              buttonText
            )}
          </Button>
        </div>
      </div>
    );
  }
}

export default compose(
  withStyles(styles),
  withTheme(),
  withSnackbar
)(AddUpdateAnchorPoint);
